export const variantConfig = {
  primary:
    'text-on-primary bg-primary shadow-lg hover:shadow-xl after:absolute after:rounded-full after:inset-0 after:shadow-[inset_0px_3px_3px_0px_rgba(255,255,255,0.28)] hover:before:scale-170 before:transition-all before:w-3/4 before:h-3/4 before:duration-300 before:-bottom-2 before:blur-md before:rounded-t-full before:bg-magenta before:absolute',
  primaryContainer: 'bg-primary-container text-on-primary-container',
  primaryOutline: 'text-primary ring-1 ring-inset ring-primary',
  info: 'bg-info text-on-info',
  infoOutline: 'text-info ring-1 ring-inset ring-info',
  success: 'bg-success text-on-success',
  successOutline: 'text-success ring-1 ring-inset ring-success',
  warning: 'bg-warning text-on-warning',
  warningOutline: 'text-warning ring-1 ring-inset ring-warning',
  white: 'bg-background text-on-surface',
  error: 'bg-error text-on-error',
  errorOutline: 'text-error ring-1 ring-inset ring-error',
  outline:
    'text-on-surface ring-1 ring-inset ring-outline-variant hover:ring-outline',
  container: 'bg-surface-container text-onSurface'
}

export const sizeConfig = {
  lg: 'py-4 px-4 has-[>span]:px-8',
  default: 'py-3 px-3 has-[>span]:px-5',
  xs: 'py-1 px-1 has-[>span]:px-2',
  sm: 'py-2 px-2 has-[>span]:px-4'
}

export const iconSizeConfig = {
  default: '20px',
  xs: '12px',
  sm: '16px',
  lg: '24px',
  xl: '26px'
}
